import { useEffect, useMemo, useState } from 'react';
import { Stack, HStack, Slider } from '@chakra-ui/react';
import { useMap } from '@/components/map/map-context';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { storageManager } from '@/lib/utils/storage-manager';

export default function PolygonOpacity() {
  const { layerGroup } = useMap();
  const [opacity, setOpacity] = useState<number[]>(() => {
    return [storageManager.loadPolygonOpacity()];
  });
  const polygonsLayer = useMemo<TileLayer<TileWMS> | null>(() => {
    if (!layerGroup) return null;
    const layers = layerGroup.getLayers().getArray();
    return (layers.find((layer) => layer.get('name') === 'Polygons') as TileLayer<TileWMS>) ?? null;
  }, [layerGroup]);

  useEffect(() => {
    if (!polygonsLayer) return;
    const storedOpacity = storageManager.loadPolygonOpacity();
    // Apply stored opacity to the layer
    if (storedOpacity) {
      polygonsLayer.setOpacity(storedOpacity / 100);
    }
  }, [polygonsLayer]);

  const handleOpacityChange = (value: number[]) => {
    setOpacity(value);
    if (polygonsLayer && value.length > 0) {
      polygonsLayer.setOpacity(value[0] / 100);
      // Save to local storage using storage manager
      storageManager.savePolygonOpacity(value[0]);
    }
  };

  return (
    <Stack gap='4' align='flex-start'>
      <Slider.Root
        size={{ base: 'lg', sm: 'md', md: 'sm' }}
        width='full'
        value={opacity}
        onValueChange={(e) => handleOpacityChange(e.value)}
      >
        <HStack justify="space-between" width='full'>
          <Slider.Label>Adjust polygon transparency</Slider.Label>
          <Slider.ValueText fontWeight='semibold'>{opacity[0]}%</Slider.ValueText>
        </HStack>
        <Slider.Control>
          <Slider.Track>
            <Slider.Range />
          </Slider.Track>
          <Slider.Thumbs />
        </Slider.Control>
      </Slider.Root>
    </Stack>
  );
}
